(function () {
  var proxy = document.getElementById('StickyAddToBagProxy');
  if (!proxy) return;

  var realButton = document.querySelector('.product-form__submit');
  if (!realButton) return;

  function sync() {
    proxy.innerHTML = realButton.innerHTML;
    proxy.disabled = realButton.disabled || realButton.getAttribute('aria-disabled') === 'true';
  }

  proxy.addEventListener('click', function () {
    realButton.click();
  });

  sync();

  var observer = new MutationObserver(sync);
  observer.observe(realButton, {
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled', 'class'],
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
